import { type FieldContentsData } from 'javascripts/shared-types';
import Field, { type Flavor } from '../../Field';

export class TeamStatusName extends Field {
  static get availableForFlavors(): readonly Flavor[] {
    return ['develop', 'teamwork'];
  }

  static attributesForModel() {
    return ['teamId'];
  }

  static subqueriesForModel() {
    return { teamWorkflowStatus: ['name'] };
  }

  get title() {
    return 'Team status name';
  }

  exampleContents(): FieldContentsData {
    return { text: 'In code review' };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.teamId && record.teamWorkflowStatus) {
      return { text: record.teamWorkflowStatus.name };
    }

    return {};
  }
}
